(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("lodash"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define('react-meeting-history',["react", "react-dom", "lodash", "moment"], factory);
	else if(typeof exports === 'object')
		exports["MeetingHistory"] = factory(require("react"), require("react-dom"), require("lodash"), require("moment"));
	else
		root["MeetingHistory"] = factory(root["react"], root["react-dom"], root["lodash"], root["moment"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_41__, __WEBPACK_EXTERNAL_MODULE_50__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MeetingHistory = __webpack_require__(1);
	
	var _MeetingHistory2 = _interopRequireDefault(_MeetingHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MeetingHistory2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactTooltip = __webpack_require__(13);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _List = __webpack_require__(28);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ShowMore = __webpack_require__(60);
	
	var _ShowMore2 = _interopRequireDefault(_ShowMore);
	
	var _RecordingDisclaimer = __webpack_require__(63);
	
	var _RecordingDisclaimer2 = _interopRequireDefault(_RecordingDisclaimer);
	
	var _NoMeetings = __webpack_require__(66);
	
	var _NoMeetings2 = _interopRequireDefault(_NoMeetings);
	
	var _internationalization = __webpack_require__(40);
	
	var _internationalization2 = _interopRequireDefault(_internationalization);
	
	__webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MeetingHistory = function (_React$Component) {
	  _inherits(MeetingHistory, _React$Component);
	
	  function MeetingHistory(props) {
	    _classCallCheck(this, MeetingHistory);
	
	    var _this = _possibleConstructorReturn(this, (MeetingHistory.__proto__ || Object.getPrototypeOf(MeetingHistory)).call(this, props));
	
	    _this.state = {
	      hideRecordingDisclaimer: true,
	      showMessageBanner: false
	    };
	    _internationalization2.default.init(props.locale, props.translations);
	    _this.handleRecordingDisclaimer = _this.handleRecordingDisclaimer.bind(_this);
	    _this.handleMessageBanner = _this.handleMessageBanner.bind(_this);
	    return _this;
	  }
	
	  _createClass(MeetingHistory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(nextProps) {
	      // if (this.props.recordingOptions) {
	      //   this.props.recordingOptions.hasRecordings().then((response) => {
	      //     this.handleRecordingDisclaimer(!response.hasRecordings);
	      //   }).fail(() => {
	      //     this.handleRecordingDisclaimer(false);
	      //   });
	      // }
	    }
	  }, {
	    key: 'handleMessageBanner',
	    value: function handleMessageBanner(val) {
	      this.setState({
	        showMessageBanner: val
	      });
	      var self = this;
	      if (val) {
	        setTimeout(function () {
	          self.handleMessageBanner(false);
	        }, 3000);
	      }
	    }
	  }, {
	    key: 'handleRecordingDisclaimer',
	    value: function handleRecordingDisclaimer(hidden) {
	      this.setState({ hideRecordingDisclaimer: hidden });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showMore = null;
	      var recordingDisclaimer = _react2.default.createElement(_RecordingDisclaimer2.default, { hidden: this.state.hideRecordingDisclaimer });
	      if (this.props.doShowMore) {
	        showMore = _react2.default.createElement(_ShowMore2.default, { showMore: this.props.showMore });
	      }
	
	      var messageBannerClass = 'info-message-banner top';
	      if (this.state.showMessageBanner) {
	        messageBannerClass += ' visible';
	      }
	
	      var messageBanner = _react2.default.createElement(
	        'div',
	        { className: messageBannerClass },
	        _react2.default.createElement('i', { className: 'togo-icon togo-icon-share-box-arrow' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          _internationalization2.default.translate('copyRecordingLink.confirmMessage')
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'meeting-details' },
	        _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', type: 'dark', place: 'top' }),
	        this.props.meetings.sessions && this.props.meetings.sessions.length > 0 ? _react2.default.createElement(_List2.default, _extends({}, this.props, { showMessageBanner: this.handleMessageBanner })) : _react2.default.createElement(_NoMeetings2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          showMore,
	          recordingDisclaimer
	        ),
	        messageBanner
	      );
	    }
	  }]);
	
	  return MeetingHistory;
	}(_react2.default.Component);
	
	exports.default = MeetingHistory;
	
	
	MeetingHistory.propTypes = {
	  meetings: _propTypes2.default.object,
	  doShowMore: _propTypes2.default.bool,
	  locale: _propTypes2.default.string,
	  translations: _propTypes2.default.object,
	  showMore: _propTypes2.default.func,
	  hasOffset: _propTypes2.default.bool,
	  recordingOptions: _propTypes2.default.shape(),
	  userSettings: _propTypes2.default.shape({
	    downloadRecordingEntitled: _propTypes2.default.bool,
	    deleteRecordingEntitled: _propTypes2.default.bool
	  })
	};
	
	MeetingHistory.defaultProps = {
	  meetings: {},
	  doShowMore: false,
	  locale: 'en',
	  translations: {},
	  showMore: function showMore() {}
	};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactIs = __webpack_require__(5);
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(8)(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(12)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (process.env.NODE_ENV === 'production') {
	  module.exports = __webpack_require__(6);
	} else {
	  module.exports = __webpack_require__(7);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/** @license React v16.8.4
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.8.4
	 * react-is.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	
	
	if (process.env.NODE_ENV !== "production") {
	  (function() {
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	
	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' ||
	  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
	}
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	{
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var lowPriorityWarning$1 = lowPriorityWarning;
	
	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;
	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;
	
	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;
	          default:
	            var $$typeofType = type && type.$$typeof;
	
	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;
	              default:
	                return $$typeof;
	            }
	        }
	      case REACT_LAZY_TYPE:
	      case REACT_MEMO_TYPE:
	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }
	
	  return undefined;
	}
	
	// AsyncMode is deprecated along with isAsyncMode
	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	
	// AsyncMode should be deprecated
	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true;
	      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }
	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	
	exports.typeOf = typeOf;
	exports.AsyncMode = AsyncMode;
	exports.ConcurrentMode = ConcurrentMode;
	exports.ContextConsumer = ContextConsumer;
	exports.ContextProvider = ContextProvider;
	exports.Element = Element;
	exports.ForwardRef = ForwardRef;
	exports.Fragment = Fragment;
	exports.Lazy = Lazy;
	exports.Memo = Memo;
	exports.Portal = Portal;
	exports.Profiler = Profiler;
	exports.StrictMode = StrictMode;
	exports.Suspense = Suspense;
	exports.isValidElementType = isValidElementType;
	exports.isAsyncMode = isAsyncMode;
	exports.isConcurrentMode = isConcurrentMode;
	exports.isContextConsumer = isContextConsumer;
	exports.isContextProvider = isContextProvider;
	exports.isElement = isElement;
	exports.isForwardRef = isForwardRef;
	exports.isFragment = isFragment;
	exports.isLazy = isLazy;
	exports.isMemo = isMemo;
	exports.isPortal = isPortal;
	exports.isProfiler = isProfiler;
	exports.isStrictMode = isStrictMode;
	exports.isSuspense = isSuspense;
	  })();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(5);
	var assign = __webpack_require__(9);
	
	var ReactPropTypesSecret = __webpack_require__(10);
	var checkPropTypes = __webpack_require__(11);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = __webpack_require__(10);
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(10);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	/* Decoraters */
	
	
	/* Utils */
	
	
	/* CSS */
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(15);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticMethods = __webpack_require__(16);
	
	var _staticMethods2 = _interopRequireDefault(_staticMethods);
	
	var _windowListener = __webpack_require__(18);
	
	var _windowListener2 = _interopRequireDefault(_windowListener);
	
	var _customEvent = __webpack_require__(19);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isCapture = __webpack_require__(20);
	
	var _isCapture2 = _interopRequireDefault(_isCapture);
	
	var _getEffect = __webpack_require__(21);
	
	var _getEffect2 = _interopRequireDefault(_getEffect);
	
	var _trackRemoval = __webpack_require__(22);
	
	var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
	
	var _getPosition = __webpack_require__(23);
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTipContent = __webpack_require__(24);
	
	var _getTipContent2 = _interopRequireDefault(_getTipContent);
	
	var _aria = __webpack_require__(25);
	
	var _nodeListToArray = __webpack_require__(26);
	
	var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
	
	var _style = __webpack_require__(27);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    _classCallCheck(this, ReactTooltip);
	
	    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
	
	    _this.state = {
	      place: props.place || 'top', // Direction of tooltip
	      desiredPlace: props.place || 'top',
	      type: 'dark', // Color theme of tooltip
	      effect: 'float', // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null, // Current mouse event
	      currentTarget: null, // Current target of mouse event
	      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: 'bind',
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          insecure = _props.insecure,
	          resizeHide = _props.resizeHide;
	
	      if (insecure) {
	        this.setStyleHeader(); // Set the style to the <link>
	      }
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var ariaProps = this.state.ariaProps;
	
	      var newAriaProps = (0, _aria.parseAria)(props);
	
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (isChanged) {
	        this.setState({ ariaProps: newAriaProps });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mount = false;
	
	      this.clearTimer();
	
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	
	  }, {
	    key: 'mouseOnToolTip',
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	        return this.tooltipRef.matches(':hover');
	      }
	      return false;
	    }
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: 'getTargetArray',
	    value: function getTargetArray(id) {
	      var targetArray = void 0;
	      if (!id) {
	        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
	      }
	      // targetArray is a NodeList, convert it to a real array
	      return (0, _nodeListToArray2.default)(targetArray);
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: 'bindListener',
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          globalEventOff = _props2.globalEventOff,
	          isCapture = _props2.isCapture;
	
	      var targetArray = this.getTargetArray(id);
	
	      targetArray.forEach(function (target) {
	        var isCaptureMode = _this3.isCapture(target);
	        var effect = _this3.getEffect(target);
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customBindListener(target);
	          return;
	        }
	
	        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	        if (effect === 'float') {
	          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	        }
	        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	      });
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: 'unbindListener',
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          globalEventOff = _props3.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        _this4.unbindBasicListener(target);
	        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	      });
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and ummount the compont
	     * it is necessary to invloke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: 'unbindBasicListener',
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent() {
	      var _props4 = this.props,
	          getContent = _props4.getContent,
	          children = _props4.children;
	
	      // Generate tooltip content
	
	      var content = void 0;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: 'isEmptyTip',
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip(e, isGlobalCall) {
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _props5 = this.props,
	          multiline = _props5.multiline,
	          getContent = _props5.getContent;
	
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it needs to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // Make sure the correct place is set
	      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
	      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
	      var result = (0, _getPosition2.default)(e, e.currentTarget, _reactDom2.default.findDOMNode(this), desiredPlace, desiredPlace, effect, offset);
	      var place = result.isNewState ? result.newState.place : desiredPlace;
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	
	      var target = e.currentTarget;
	
	      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
	
	      var self = this;
	
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute('data-type') || self.props.type || 'dark',
	          effect: effect,
	          offset: offset,
	          html: target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html || false,
	          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
	          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
	          border: target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border || false,
	          extraClass: target.getAttribute('data-class') || self.props.class || self.props.className || '',
	          disable: target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) self.addScrollListener(self.state.currentTarget);
	          self.updateTooltip(e);
	
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	
	                var placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      };
	
	      // If there is no delay call immediately, don't allow events to get in first.
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse hover, updatetooltip
	     */
	
	  }, {
	    key: 'updateTooltip',
	    value: function updateTooltip(e) {
	      var _this5 = this;
	
	      var _state = this.state,
	          delayShow = _state.delayShow,
	          disable = _state.disable;
	      var afterShow = this.props.afterShow;
	
	      var placeholder = this.getTooltipContent();
	      var delayTime = parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target;
	
	      // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	      if (this.mouseOnToolTip()) {
	        return;
	      }
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition();
	            if (isInvisible && afterShow) afterShow(e);
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	
	    /*
	    * If we're mousing over the tooltip remove it when we leave.
	     */
	
	  }, {
	    key: 'listenForTooltipExit',
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	  }, {
	    key: 'removeListenerForTooltipExit',
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	
	      var _state2 = this.state,
	          delayHide = _state2.delayHide,
	          disable = _state2.disable;
	      var afterHide = this.props.afterHide;
	
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show;
	        // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	          return;
	        }
	        _this6.removeListenerForTooltipExit();
	
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener();
	          if (isVisible && afterHide) afterHide(e);
	        });
	      };
	
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * Add scroll eventlistener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: 'addScrollListener',
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'removeScrollListener',
	    value: function removeScrollListener() {
	      window.removeEventListener('scroll', this.hideTooltip);
	    }
	
	    // Calculation the position
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _this7 = this;
	
	      var _state3 = this.state,
	          currentEvent = _state3.currentEvent,
	          currentTarget = _state3.currentTarget,
	          place = _state3.place,
	          desiredPlace = _state3.desiredPlace,
	          effect = _state3.effect,
	          offset = _state3.offset;
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition();
	        });
	      }
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	  }, {
	    key: 'setStyleHeader',
	    value: function setStyleHeader() {
	      var head = document.getElementsByTagName('head')[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        var tag = document.createElement('style');
	        tag.id = 'react-tooltip';
	        tag.innerHTML = _style2.default;
	        /* eslint-disable */
	        if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
	          tag.setAttribute('nonce', __webpack_nonce__);
	        }
	        /* eslint-enable */
	        head.insertBefore(tag, head.firstChild);
	      }
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearTimeout(this.delayReshow);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state4 = this.state,
	          extraClass = _state4.extraClass,
	          html = _state4.html,
	          ariaProps = _state4.ariaProps,
	          disable = _state4.disable;
	
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' }, { 'allow_hover': this.props.delayUpdate }, { 'allow_click': this.props.clickable });
	
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      if (html) {
	        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass,
	          id: this.props.id,
	          ref: function ref(_ref) {
	            return _this8.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          'data-id': 'tooltip',
	          dangerouslySetInnerHTML: { __html: placeholder } }));
	      } else {
	        return _react2.default.createElement(
	          Wrapper,
	          _extends({ className: tooltipClass + ' ' + extraClass,
	            id: this.props.id
	          }, ariaProps, {
	            ref: function ref(_ref2) {
	              return _this8.tooltipRef = _ref2;
	            },
	            'data-id': 'tooltip' }),
	          placeholder
	        );
	      }
	    }
	  }]);
	
	  return ReactTooltip;
	}(_react2.default.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  place: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  effect: _propTypes2.default.string,
	  offset: _propTypes2.default.object,
	  multiline: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  insecure: _propTypes2.default.bool,
	  class: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  html: _propTypes2.default.bool,
	  delayHide: _propTypes2.default.number,
	  delayUpdate: _propTypes2.default.number,
	  delayShow: _propTypes2.default.number,
	  event: _propTypes2.default.string,
	  eventOff: _propTypes2.default.string,
	  watchWindow: _propTypes2.default.bool,
	  isCapture: _propTypes2.default.bool,
	  globalEventOff: _propTypes2.default.string,
	  getContent: _propTypes2.default.any,
	  afterShow: _propTypes2.default.func,
	  afterHide: _propTypes2.default.func,
	  disable: _propTypes2.default.bool,
	  scrollHide: _propTypes2.default.bool,
	  resizeHide: _propTypes2.default.bool,
	  wrapper: _propTypes2.default.string,
	  clickable: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div',
	  clickable: false
	}, _class2.supportedWrappers = ['div', 'span'], _class2.displayName = 'ReactTooltip', _temp)) || _class) || _class) || _class) || _class) || _class) || _class;
	
	/* export default not fit for standalone, it will exports {default:...} */
	
	
	module.exports = ReactTooltip;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = { currentTarget: event.detail.target };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
	    }
	  };
	};
	
	var _constant = __webpack_require__(17);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatibale with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event = void 0;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, { detail: opts });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	}; /**
	    * Static methods for react-tooltip
	    */

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	};
	
	var _constant = __webpack_require__(17);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff;
	
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _state2 = this.state,
	        event = _state2.event,
	        eventOff = _state2.eventOff;
	
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	};
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	
	  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
	  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListeners = {
	  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
	  };
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	            return;
	          }
	        }
	      }
	    });
	
	    observer.observe(window.document, { childList: true, subtree: true });
	
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	};
	
	/**
	 * Tracking target removing from DOM.
	 * It's nessesary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  };
	
	  // Check whether the tooltip with orientation p is completely inside the client window
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	
	  var placesList = ['top', 'bottom', 'left', 'right'];
	  var insideList = [];
	  for (var i = 0; i < 4; i++) {
	    var p = placesList[i];
	    if (inside(p)) {
	      insideList.push(p);
	    }
	  }
	
	  var isNewState = false;
	  var newPlace = void 0;
	  if (inside(desiredPlace) && desiredPlace !== place) {
	    isNewState = true;
	    newPlace = desiredPlace;
	  } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
	    isNewState = true;
	    newPlace = insideList[0];
	  }
	
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: { place: newPlace }
	    };
	  }
	
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	};
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	};
	
	// Get current mouse offset
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top = void 0;
	  var right = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return { top: top, bottom: bottom, left: left, right: right };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	
	  return { parentTop: parentTop, parentLeft: parentLeft };
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and childern is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: i, className: 'multi-line' },
	      d
	    );
	  });
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAria = parseAria;
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return (/(^aria-\w+$|^role$)/.test(prop)
	    );
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	
	  return ariaObj;
	}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip.allow_hover,.__react_component_tooltip.allow_click{pointer-events:auto}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MoreOptions = __webpack_require__(29);
	
	var _MoreOptions2 = _interopRequireDefault(_MoreOptions);
	
	var _DateTime = __webpack_require__(49);
	
	var _DateTime2 = _interopRequireDefault(_DateTime);
	
	var _MeetingInfo = __webpack_require__(53);
	
	var _MeetingInfo2 = _interopRequireDefault(_MeetingInfo);
	
	var _Attendees = __webpack_require__(56);
	
	var _Attendees2 = _interopRequireDefault(_Attendees);
	
	var _calculateAttendeeCount = __webpack_require__(59);
	
	var _calculateAttendeeCount2 = _interopRequireDefault(_calculateAttendeeCount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var List = function (_React$Component) {
	  _inherits(List, _React$Component);
	
	  function List() {
	    _classCallCheck(this, List);
	
	    return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
	  }
	
	  _createClass(List, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var MeetingInfoClassName = this.props.hasOffset ? 'col-sm-6' : 'col-sm-4';
	      var DateTimeClassName = this.props.hasOffset ? 'col-sm-offset-1' : '';
	      var MoreOptionsClassName = this.props.hasOffset ? 'col-sm-2' : 'col-sm-4';
	
	      var meetings = this.props.meetings.sessions.map(function (session) {
	        return _react2.default.createElement(
	          'div',
	          { key: session.sessionId, className: 'row detail' },
	          _react2.default.createElement(
	            'div',
	            { className: 'meeting-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'container' },
	              _react2.default.createElement(_DateTime2.default, {
	                meetingStartTime: session.timeStrings.meetingStartTime,
	                meetingStartPeriod: session.timeStrings.meetingStartPeriod,
	                meetingDate: session.timeStrings.meetingDate,
	                is24Hours: _this2.props.is24Hours,
	                className: DateTimeClassName
	              }),
	              _react2.default.createElement(_MeetingInfo2.default, {
	                meetingStartTime: session.startTime,
	                meetingEndTime: session.endTime,
	                meetingId: session.meetingId,
	                sessionId: session.sessionId,
	                subject: session.subject,
	                className: MeetingInfoClassName
	              }),
	              _react2.default.createElement(_MoreOptions2.default, {
	                className: MoreOptionsClassName,
	                session: session,
	                recording: session.recording,
	                recordingOptions: _this2.props.recordingOptions,
	                meetingId: session.meetingId,
	                showMessageBanner: _this2.props.showMessageBanner,
	                onCloudRecordingAction: _this2.props.onCloudRecordingAction,
	                userSettings: _this2.props.userSettings,
	                meetingDiagnosticsBaseUrl: _this2.props.meetingDiagnosticsBaseUrl
	              }),
	              _react2.default.createElement(_Attendees2.default, {
	                meetingData: session,
	                viewAttendees: _this2.props.viewReport,
	                attendeesCount: (0, _calculateAttendeeCount2.default)(session.attendees)
	              })
	            )
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        meetings
	      );
	    }
	  }]);
	
	  return List;
	}(_react2.default.Component);
	
	exports.default = List;
	
	
	List.propTypes = {
	  is24Hours: _propTypes2.default.bool,
	  meetings: _propTypes2.default.object,
	  viewReport: _propTypes2.default.func,
	  onCloudRecordingAction: _propTypes2.default.func,
	  hasOffset: _propTypes2.default.bool,
	  locale: _propTypes2.default.string,
	  recordingOptions: _propTypes2.default.shape({
	    confirmDeleteRecordingHandler: function confirmDeleteRecordingHandler() {}
	  }),
	  showMessageBanner: _propTypes2.default.func,
	  userSettings: _propTypes2.default.shape({
	    downloadRecordingEntitled: _propTypes2.default.bool,
	    deleteRecordingEntitled: _propTypes2.default.bool
	  }),
	  meetingDiagnosticsBaseUrl: _propTypes2.default.string
	};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _copyToClipboard = __webpack_require__(30);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	__webpack_require__(32);
	
	var _ModalDialog = __webpack_require__(36);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _internationalization = __webpack_require__(40);
	
	var _internationalization2 = _interopRequireDefault(_internationalization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MoreOptions = function (_Component) {
	  _inherits(MoreOptions, _Component);
	
	  _createClass(MoreOptions, null, [{
	    key: 'computeMegaBytes',
	    value: function computeMegaBytes(byte) {
	      var result = 0;
	      var unit = 'MB';
	      if (byte && typeof byte === 'number' && byte > 0) {
	        result = Math.ceil(byte / 1024 / 1024);
	      }
	      if (result > 1024) {
	        result = Math.ceil(result / 1024);
	        unit = 'GB';
	      }
	      return [result, unit].join('');
	    }
	  }]);
	
	  function MoreOptions(props) {
	    _classCallCheck(this, MoreOptions);
	
	    var _this = _possibleConstructorReturn(this, (MoreOptions.__proto__ || Object.getPrototypeOf(MoreOptions)).call(this, props));
	
	    var status = 'norecording';
	    if (_this.props.recording) {
	      status = _this.props.recording.stored ? 'ready' : 'processing';
	    }
	
	    _this.state = {
	      recordingStatus: status,
	      showDeleteConfirmDialog: false,
	      showDeleteErrorDialog: false,
	      showBusyIndicator: false,
	      showCopyLinkDialog: false,
	      showCopyLinkErrorDialog: false,
	      linkToCopy: '',
	      isPublic: false
	    };
	
	    _this.handleCopyLinkClick = _this.handleCopyLinkClick.bind(_this);
	    _this.handleToggleSharing = _this.handleToggleSharing.bind(_this);
	    _this.handleDeleteRecording = _this.handleDeleteRecording.bind(_this);
	    _this.handleOpenConfirmDialog = _this.handleOpenConfirmDialog.bind(_this);
	    _this.handleCloseConfirmDialog = _this.handleCloseConfirmDialog.bind(_this);
	    _this.handleCloseErrorDialog = _this.handleCloseErrorDialog.bind(_this);
	    _this.handleDeleteRecordingError = _this.handleDeleteRecordingError.bind(_this);
	    _this.showDeleteRecordingErrorDialog = _this.showDeleteRecordingErrorDialog.bind(_this);
	    _this.showBusyIndicator = _this.showBusyIndicator.bind(_this);
	    _this.showCopyLinkDialog = _this.showCopyLinkDialog.bind(_this);
	    _this.showCopyLinkErrorDialog = _this.showCopyLinkErrorDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(MoreOptions, [{
	    key: 'showBusyIndicator',
	    value: function showBusyIndicator(val) {
	      this.setState({
	        showBusyIndicator: val
	      });
	    }
	  }, {
	    key: 'showCopyLinkDialog',
	    value: function showCopyLinkDialog(val) {
	      var _this2 = this;
	
	      this.setState({
	        showCopyLinkDialog: val
	      });
	
	      if (val) {
	        this.props.recordingOptions.fetchSharedLink(this.props.session).then(function (resp) {
	          if (resp.link) {
	            _this2.setState({ linkToCopy: resp.link, isPublic: resp.isPublic });
	          } else {
	            _this2.showCopyLinkDialog(false);
	            _this2.showCopyLinkErrorDialog();
	          }
	        }).fail(function () {
	          _this2.showCopyLinkDialog(false);
	          _this2.showCopyLinkErrorDialog();
	        });
	      } else {
	        this.setState({
	          linkToCopy: ''
	        });
	      }
	    }
	  }, {
	    key: 'handleToggleSharing',
	    value: function handleToggleSharing(val) {
	      this.props.recordingOptions.createSharedLink(this.props.session, val);
	      this.setState({
	        isPublic: val
	      });
	    }
	  }, {
	    key: 'handleCopyLinkClick',
	    value: function handleCopyLinkClick() {
	      if (this.state.linkToCopy.length > 0) {
	        if ((0, _copyToClipboard2.default)(this.state.linkToCopy)) {
	          this.props.showMessageBanner(true);
	        }
	        this.showCopyLinkDialog(false);
	        this.props.onCloudRecordingAction('share', this.props.recording, this.props.meetingId);
	      }
	    }
	  }, {
	    key: 'handleOpenConfirmDialog',
	    value: function handleOpenConfirmDialog() {
	      this.setState({
	        showDeleteConfirmDialog: true
	      });
	    }
	  }, {
	    key: 'handleCloseConfirmDialog',
	    value: function handleCloseConfirmDialog() {
	      this.setState({
	        showDeleteConfirmDialog: false
	      });
	      this.showCopyLinkDialog(false);
	    }
	  }, {
	    key: 'showCopyLinkErrorDialog',
	    value: function showCopyLinkErrorDialog() {
	      this.setState({
	        showDeleteConfirmDialog: false,
	        showDeleteErrorDialog: false,
	        showCopyLinkErrorDialog: true
	      });
	    }
	  }, {
	    key: 'showDeleteRecordingErrorDialog',
	    value: function showDeleteRecordingErrorDialog() {
	      this.setState({
	        showDeleteConfirmDialog: false,
	        showDeleteErrorDialog: true
	      });
	    }
	  }, {
	    key: 'handleCloseErrorDialog',
	    value: function handleCloseErrorDialog() {
	      this.setState({
	        showDeleteErrorDialog: false,
	        showCopyLinkErrorDialog: false
	      });
	    }
	  }, {
	    key: 'handleDeleteRecordingError',
	    value: function handleDeleteRecordingError() {
	      this.showDeleteRecordingErrorDialog();
	    }
	  }, {
	    key: 'handleDeleteRecording',
	    value: function handleDeleteRecording() {
	      var self = this;
	      this.props.recordingOptions.onDeleteRecordingClick(this.props.session.sessionId).then(function () {
	        setTimeout(function () {
	          self.setState({
	            recordingStatus: 'norecording'
	          });
	        }, 300);
	        self.setState({
	          recordingStatus: 'deleted'
	        });
	        self.props.onCloudRecordingAction('delete', self.props.recording, self.props.meetingId);
	        self.handleCloseConfirmDialog();
	      }).fail(function () {
	        self.handleDeleteRecordingError();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var container = null;
	      var processingIndicator = '';
	      var playButton = '';
	      var shareButton = '';
	      var downloadButton = '';
	      var deleteButton = '';
	      var diagnosticsButton = '';
	
	      switch (this.state.recordingStatus) {
	        case 'processing':
	          {
	            processingIndicator = _react2.default.createElement(
	              'div',
	              { className: 'options processing' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _internationalization2.default.translate('processing')
	              ),
	              _react2.default.createElement('i', { className: 'togo-icon togo-icon-settings togo-icon spin-large' }),
	              _react2.default.createElement('i', { className: 'togo-icon togo-icon-settings togo-icon spin-small' })
	            );
	            break;
	          }
	        case 'deleted':
	        case 'ready':
	          {
	            var transcriptEnabled = this.props.recording.transcriptEnabled;
	
	            var playLinkDivClass = 'options ready play';
	            playLinkDivClass += transcriptEnabled ? ' transcript' : '';
	            playButton = _react2.default.createElement(
	              'div',
	              { className: playLinkDivClass },
	              _react2.default.createElement(
	                'a',
	                {
	                  href: this.props.recordingOptions.transcriptsUrl + '/#/sessionId/' + this.props.session.sessionId,
	                  className: 'more-options-button play',
	                  target: '_blank',
	                  rel: 'noopener noreferrer'
	                },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  transcriptEnabled ? _internationalization2.default.translate('viewTranscript') : _internationalization2.default.translate('play'),
	                  '\xA0'
	                ),
	                _react2.default.createElement('i', { className: 'togo-icon togo-icon-play togo-icon-lg' })
	              )
	            );
	
	            shareButton = _react2.default.createElement(
	              'div',
	              { className: 'options ready share' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-link',
	                  'data-automation-id': 'rec-copy-link',
	                  onClick: this.showCopyLinkDialog
	                },
	                _react2.default.createElement('i', { className: 'togo-icon togo-icon-share-box-arrow togo-icon-lg', 'data-tip': _internationalization2.default.translate('shareRecording') })
	              )
	            );
	
	            if (this.props.userSettings.downloadRecordingEntitled) {
	              var tooltip = _internationalization2.default.translate('downloadRecording') + ' (' + MoreOptions.computeMegaBytes(this.props.recording.fileSize) + ')';
	
	              downloadButton = _react2.default.createElement(
	                'div',
	                { className: 'options ready download' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'btn btn-link',
	                    'data-automation-id': 'rec-download',
	                    href: this.props.recording.downloadUrl,
	                    onClick: function onClick() {
	                      return _this3.props.onCloudRecordingAction('download', _this3.props.recording, _this3.props.meetingId);
	                    }
	                  },
	                  _react2.default.createElement('i', { className: 'togo-icon togo-icon-download togo-icon-lg', 'data-tip': tooltip })
	                )
	              );
	            }
	
	            if (this.props.userSettings.deleteRecordingEntitled) {
	              deleteButton = _react2.default.createElement(
	                'div',
	                { className: 'options ready delete' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn-link',
	                    'data-automation-id': 'rec-delete',
	                    onClick: this.handleOpenConfirmDialog
	                  },
	                  _react2.default.createElement('i', { className: 'togo-icon togo-icon-trash togo-icon-lg', 'data-tip': _internationalization2.default.translate('deleteRecording') })
	                )
	              );
	            }
	            break;
	          }
	        default:
	        // NOOP
	      }
	
	      var diagnosticsAvailable = this.props.meetingDiagnosticsBaseUrl && this.props.session.diagnosticsProcessingStatus === 'available';
	
	      if (diagnosticsAvailable) {
	        diagnosticsButton = _react2.default.createElement(
	          'div',
	          { className: 'options diagnostics' },
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'btn btn-link',
	              'data-automation-id': 'diagnostics',
	              href: '' + this.props.meetingDiagnosticsBaseUrl + this.props.session.sessionId,
	              target: '_blank',
	              rel: 'noopener noreferrer'
	            },
	            _react2.default.createElement('i', { className: 'togo-icon togo-icon-healthcare togo-icon-lg', 'data-tip': _internationalization2.default.translate('diagnostics') })
	          )
	        );
	      }
	
	      var moreOptionsClass = 'more-options';
	      moreOptionsClass += this.state.recordingStatus === 'deleted' ? ' fadeout' : '';
	
	      container = _react2.default.createElement(
	        'div',
	        { className: 'more-options-container', style: { fontSize: '14px' } },
	        _react2.default.createElement(
	          'div',
	          { className: moreOptionsClass },
	          processingIndicator,
	          playButton,
	          shareButton,
	          downloadButton,
	          deleteButton,
	          diagnosticsButton
	        )
	      );
	      // }
	
	      var dialogBodyText = '';
	      if (this.props.recording) {
	        dialogBodyText = _internationalization2.default.t('deleteRecordings.confirmDialog.body', this.props.recording.recordingName);
	      }
	
	      var deleteConfirmDialog = null;
	      if (this.state.showDeleteConfirmDialog) {
	        deleteConfirmDialog = _react2.default.createElement(_ModalDialog2.default, {
	          dialogHeadText: _internationalization2.default.translate('deleteRecordings.confirmDialog.head'),
	          dialogBodyText: dialogBodyText,
	          dialogType: 'confirm',
	          cancelButtonText: _internationalization2.default.translate('cancel'),
	          confirmButtonText: _internationalization2.default.translate('yes'),
	          showCancelIcon: true,
	          handleCancelClick: this.handleCloseConfirmDialog,
	          handleConfirmClick: this.handleDeleteRecording
	        });
	      }
	
	      var copyLinkDialog = null;
	      if (this.state.showCopyLinkDialog) {
	        copyLinkDialog = _react2.default.createElement(_ModalDialog2.default, {
	          dialogType: 'copy',
	          showCancelIcon: true,
	          dialogHeadText: _internationalization2.default.translate('copyLinkDlgHeader'),
	          dialogBodyText: this.state.linkToCopy,
	          cancelButtonText: _internationalization2.default.translate('cancel'),
	          confirmButtonText: _internationalization2.default.translate('confirmCopyLink'),
	          toggleSharingText: _internationalization2.default.translate('toggleSharingText'),
	          isPublic: this.state.isPublic,
	          handleToggleClick: this.handleToggleSharing,
	          handleConfirmClick: this.handleCopyLinkClick,
	          handleCancelClick: this.handleCloseConfirmDialog
	        });
	      }
	
	      var copyLinkErrorDialog = null;
	      if (this.state.showCopyLinkErrorDialog) {
	        copyLinkErrorDialog = _react2.default.createElement(_ModalDialog2.default, {
	          dialogHeadText: _internationalization2.default.translate('copyRecordingLink.errorDialog.head'),
	          dialogBodyText: _internationalization2.default.translate('copyRecordingLink.errorDialog.body'),
	          dialogType: 'error',
	          cancelButtonText: _internationalization2.default.translate('cancel'),
	          showCancelIcon: true,
	          handleCancelClick: this.handleCloseErrorDialog
	        });
	      }
	
	      var deleteRecordingErrorDialog = null;
	      if (this.state.showDeleteErrorDialog) {
	        deleteRecordingErrorDialog = _react2.default.createElement(_ModalDialog2.default, {
	          dialogHeadText: _internationalization2.default.translate('deleteRecordings.errorDialog.head'),
	          dialogBodyText: _internationalization2.default.translate('deleteRecordings.errorDialog.body'),
	          dialogType: 'error',
	          cancelButtonText: _internationalization2.default.translate('cancel'),
	          showCancelIcon: true,
	          handleCancelClick: this.handleCloseErrorDialog
	        });
	      }
	
	      var busyIndicator = null;
	      if (this.state.showBusyIndicator) {
	        busyIndicator = _react2.default.createElement(_ModalDialog2.default, { dialogType: 'busy-g2m' });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className },
	        container,
	        deleteConfirmDialog,
	        deleteRecordingErrorDialog,
	        copyLinkDialog,
	        copyLinkErrorDialog,
	        busyIndicator
	      );
	    }
	  }]);
	
	  return MoreOptions;
	}(_react.Component);
	
	exports.default = MoreOptions;
	
	
	MoreOptions.propTypes = {
	  className: _propTypes2.default.string.isRequired,
	  recordingOptions: _propTypes2.default.shape({
	    onDeleteRecordingClick: _propTypes2.default.func,
	    fetchSharedLink: _propTypes2.default.func,
	    createSharedLink: _propTypes2.default.func,
	    transcriptsUrl: _propTypes2.default.string
	  }).isRequired,
	  session: _propTypes2.default.shape({
	    diagnosticsProcessingStatus: _propTypes2.default.string,
	    sessionId: _propTypes2.default.string
	  }).isRequired,
	  recording: _propTypes2.default.shape({
	    recordingId: _propTypes2.default.string,
	    recordingName: _propTypes2.default.string,
	    transcoded: _propTypes2.default.bool,
	    transcriptEnabled: _propTypes2.default.bool,
	    stored: _propTypes2.default.bool,
	    downloadUrl: _propTypes2.default.string,
	    fileSize: _propTypes2.default.number
	  }),
	  meetingId: _propTypes2.default.string,
	  onCloudRecordingAction: _propTypes2.default.func,
	  showMessageBanner: _propTypes2.default.func,
	  userSettings: _propTypes2.default.shape({
	    downloadRecordingEntitled: _propTypes2.default.bool,
	    deleteRecordingEntitled: _propTypes2.default.bool
	  }),
	  meetingDiagnosticsBaseUrl: _propTypes2.default.string
	};
	
	MoreOptions.defaultProps = {
	  recordingOptions: {
	    onDeleteRecordingClick: function onDeleteRecordingClick() {},
	    fetchSharedLink: function fetchSharedLink() {},
	    createSharedLink: function createSharedLink() {},
	    transcriptsUrl: ''
	  },
	  session: {},
	  recording: null,
	  onCloudRecordingAction: function onCloudRecordingAction() {},
	  userSettings: {}
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deselectCurrent = __webpack_require__(31);
	
	var defaultMessage = 'Copy to clipboard: #{key}, Enter';
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug, message, reselectPrevious, range, selection, mark, success = false;
	  if (!options) { options = {}; }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement('span');
	    mark.textContent = text;
	    // reset user styles for span element
	    mark.style.all = 'unset';
	    // prevents scrolling to the end of the page
	    mark.style.position = 'fixed';
	    mark.style.top = 0;
	    mark.style.clip = 'rect(0, 0, 0, 0)';
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = 'pre';
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = 'text';
	    mark.style.MozUserSelect = 'text';
	    mark.style.msUserSelect = 'text';
	    mark.style.userSelect = 'text';
	
	    document.body.appendChild(mark);
	
	    range.selectNode(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand('copy');
	    if (!successful) {
	      throw new Error('copy command was unsuccessful');
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error('unable to copy using execCommand: ', err);
	    debug && console.warn('trying IE specific stuff');
	    try {
	      window.clipboardData.setData('text', text);
	      success = true;
	    } catch (err) {
	      debug && console.error('unable to copy using clipboardData: ', err);
	      debug && console.error('falling back to prompt');
	      message = format('message' in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == 'function') {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(37);
	
	var _Switch = __webpack_require__(39);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TYPE_ERROR = 'error';
	var TYPE_CONFIRM = 'confirm';
	var TYPE_BUSY = 'busy';
	var TYPE_BUSY_G2M = 'busy-g2m';
	var TYPE_CUSTOM = 'custom';
	var TYPE_COPY = 'copy';
	
	var ModalDialog = function (_Component) {
	  _inherits(ModalDialog, _Component);
	
	  function ModalDialog(props) {
	    _classCallCheck(this, ModalDialog);
	
	    var _this = _possibleConstructorReturn(this, (ModalDialog.__proto__ || Object.getPrototypeOf(ModalDialog)).call(this, props));
	
	    _this.state = {
	      dialogBodyText: _this.props.dialogBodyText
	    };
	
	    _this.selectUrlToCopy = _this.selectUrlToCopy.bind(_this);
	    _this.createContent = _this.createContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(ModalDialog, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.backdrop = document.createElement('div');
	      this.backdrop.setAttribute('class', 'recording-options-modal backdrop');
	      document.body.appendChild(this.backdrop);
	      this.renderPopup();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dialogBodyText: nextProps.dialogBodyText
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.selectUrlToCopy();
	      this.renderPopup();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.backdrop);
	      document.body.removeChild(this.backdrop);
	    }
	  }, {
	    key: 'renderPopup',
	    value: function renderPopup() {
	      _reactDom2.default.render(this.popup, this.backdrop);
	    }
	  }, {
	    key: 'selectUrlToCopy',
	    value: function selectUrlToCopy() {
	      var input = document.getElementById('inputCopyShareUrl');
	      if (input && this.props.dialogType === TYPE_COPY && this.state.dialogBodyText && this.state.dialogBodyText.length > 0) {
	        input.select();
	        input.focus();
	      }
	    }
	  }, {
	    key: 'createContent',
	    value: function createContent(cancelIcon, bodyContent, buttons) {
	      switch (this.props.dialogType) {
	        case TYPE_ERROR:
	        case TYPE_CONFIRM:
	          return _react2.default.createElement(
	            'div',
	            { className: 'recording-options-modal popup' },
	            _react2.default.createElement(
	              'div',
	              { className: 'dialog-head', 'data-automation-id': 'modal-head' },
	              _react2.default.createElement(
	                'span',
	                { className: 'text' },
	                this.props.dialogHeadText
	              ),
	              cancelIcon
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'dialog-body', 'data-automation-id': 'modal-body' },
	              bodyContent
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'dialog-foot' },
	              buttons
	            )
	          );
	        case TYPE_COPY:
	          {
	            var bodyContentResult = bodyContent;
	            if (!bodyContent || bodyContent.length < 1) {
	              bodyContentResult = _react2.default.createElement(
	                'div',
	                { className: 'spinner' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'togo-icon-stack togo-icon-4x togo-icon-spinner-stack secondary spinner-g2m' },
	                  _react2.default.createElement('i', { className: 'togo-icon-stack-1x togo-icon togo-icon-spinner' }),
	                  _react2.default.createElement('i', { className: 'togo-icon-stack-1x togo-icon togo-icon-spinner-segment' })
	                )
	              );
	            }
	            return _react2.default.createElement(
	              'div',
	              { className: 'recording-options-modal popup' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dialog-head', 'data-automation-id': 'modal-head' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'text' },
	                  this.props.dialogHeadText
	                ),
	                cancelIcon
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dialog-body', 'data-automation-id': 'modal-body' },
	                bodyContentResult
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dialog-foot' },
	                buttons
	              )
	            );
	          }
	        case TYPE_BUSY:
	          return _react2.default.createElement('div', { className: 'recording-options-modal spinner' });
	        case TYPE_BUSY_G2M:
	          return _react2.default.createElement(
	            'span',
	            { className: 'togo-icon-stack togo-icon-4x togo-icon-spinner-stack secondary spinner-g2m' },
	            _react2.default.createElement('i', { className: 'togo-icon-stack-1x togo-icon togo-icon-spinner' }),
	            _react2.default.createElement('i', { className: 'togo-icon-stack-1x togo-icon togo-icon-spinner-segment' })
	          );
	        default:
	        // NOOP
	      }
	      return null;
	    }
	  }, {
	    key: 'handleCancelClick',
	    value: function handleCancelClick() {
	      this.setState({
	        bodyText: ''
	      });
	      this.props.handleCancelClick();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var content = null;
	
	      if (this.props.dialogType === TYPE_CUSTOM) {
	        content = this.props.children;
	      } else {
	        var buttons = null;
	
	        var cancelButton = _react2.default.createElement(
	          'button',
	          {
	            className: 'btn-link cancel',
	            onClick: this.props.handleCancelClick
	          },
	          this.props.cancelButtonText
	        );
	        var confirmButton = _react2.default.createElement(
	          'button',
	          {
	            className: 'btn confirm',
	            onClick: this.props.handleConfirmClick
	          },
	          this.props.confirmButtonText
	        );
	
	        var cancelIcon = null;
	        if (this.props.showCancelIcon) {
	          cancelIcon = _react2.default.createElement('i', { className: 'togo-icon togo-icon-closes cancel-icon', onClick: this.props.handleCancelClick });
	        }
	
	        var bodyContent = null;
	        if (this.state.dialogBodyText) {
	          if (this.props.dialogType === TYPE_COPY) {
	            bodyContent = _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('input', {
	                type: 'text',
	                id: 'inputCopyShareUrl',
	                className: 'copy',
	                value: this.state.dialogBodyText,
	                readOnly: true,
	                onClick: this.selectUrlToCopy,
	                onFocus: this.selectUrlToCopy
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'toggleSharing' },
	                _react2.default.createElement(_Switch2.default, { on: this.props.isPublic, id: 'isShared', onChange: this.props.handleToggleClick }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'toggleSharingText', htmlFor: 'isShared' },
	                  this.props.toggleSharingText
	                )
	              )
	            );
	          } else {
	            bodyContent = _react2.default.createElement(
	              'span',
	              { className: 'text' },
	              this.state.dialogBodyText
	            );
	          }
	        } else {
	          bodyContent = this.props.children;
	        }
	
	        switch (this.props.dialogType) {
	          case TYPE_CONFIRM:
	            buttons = _react2.default.createElement(
	              'div',
	              null,
	              cancelButton,
	              confirmButton
	            );
	            content = this.createContent(cancelIcon, bodyContent, buttons);
	            break;
	          case TYPE_ERROR:
	            buttons = _react2.default.createElement(
	              'div',
	              null,
	              cancelButton
	            );
	            content = this.createContent(cancelIcon, bodyContent, buttons);
	            break;
	          case TYPE_COPY:
	            buttons = _react2.default.createElement(
	              'div',
	              null,
	              cancelButton,
	              confirmButton
	            );
	
	            content = this.createContent(cancelIcon, bodyContent, buttons);
	            break;
	          case TYPE_BUSY_G2M:
	          case TYPE_BUSY:
	            content = this.createContent();
	            break;
	          default:
	          // NOOP
	        }
	      }
	      this.popup = content;
	      return null;
	    }
	  }]);
	
	  return ModalDialog;
	}(_react.Component);
	
	exports.default = ModalDialog;
	
	
	ModalDialog.propTypes = {
	  dialogHeadText: _propTypes2.default.string,
	  dialogBodyText: _propTypes2.default.string,
	  toggleSharingText: _propTypes2.default.string,
	  dialogType: _propTypes2.default.oneOf([TYPE_CONFIRM, TYPE_ERROR, TYPE_BUSY, TYPE_BUSY_G2M, TYPE_CUSTOM, TYPE_COPY]),
	  cancelButtonText: _propTypes2.default.string,
	  confirmButtonText: _propTypes2.default.string,
	  showCancelIcon: _propTypes2.default.bool,
	  handleCancelClick: _propTypes2.default.func,
	  handleConfirmClick: _propTypes2.default.func,
	  children: _propTypes2.default.node,
	  handleToggleClick: _propTypes2.default.func,
	  isPublic: _propTypes2.default.bool
	};
	
	ModalDialog.defaultProps = {
	  dialogHeadText: '',
	  dialogBodyText: null,
	  dialogType: TYPE_CONFIRM,
	  cancelButtonText: '_cancel_',
	  confirmButtonText: '_confirm_',
	  showCancelIcon: true,
	  handleCancelClick: function handleCancelClick() {},
	  handleConfirmClick: function handleConfirmClick() {}
	};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Switch = function (_Component) {
	  _inherits(Switch, _Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
	  }
	
	  _createClass(Switch, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'toggle-switch size-xs' },
	        _react2.default.createElement('input', {
	          type: 'checkbox',
	          id: this.props.id,
	          checked: this.props.on,
	          onChange: function onChange(event) {
	            return _this2.props.onChange(event.target.checked);
	          }
	        }),
	        _react2.default.createElement('label', { htmlFor: this.props.id }),
	        _react2.default.createElement('label', { htmlFor: this.props.id, className: 'toggle-switch-hint' })
	      );
	    }
	  }]);
	
	  return Switch;
	}(_react.Component);
	
	exports.default = Switch;
	
	
	Switch.propTypes = {
	  id: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  on: _propTypes2.default.bool
	};
	
	Switch.defaultProps = {
	  onChange: function onChange() {}
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(41);
	
	var _translation = __webpack_require__(42);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	var _translation3 = __webpack_require__(43);
	
	var _translation4 = _interopRequireDefault(_translation3);
	
	var _translation5 = __webpack_require__(44);
	
	var _translation6 = _interopRequireDefault(_translation5);
	
	var _translation7 = __webpack_require__(45);
	
	var _translation8 = _interopRequireDefault(_translation7);
	
	var _translation9 = __webpack_require__(46);
	
	var _translation10 = _interopRequireDefault(_translation9);
	
	var _translation11 = __webpack_require__(47);
	
	var _translation12 = _interopRequireDefault(_translation11);
	
	var _translation13 = __webpack_require__(48);
	
	var _translation14 = _interopRequireDefault(_translation13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var parseLocale = function parseLocale(locale) {
	  var translations = {};
	  switch (true) {
	    case locale.indexOf('en') > -1:
	      translations = _translation2.default;
	      break;
	    case locale.indexOf('de') > -1:
	      translations = _translation4.default;
	      break;
	    case locale.indexOf('es') > -1:
	      translations = _translation6.default;
	      break;
	    case locale.indexOf('fr') > -1:
	      translations = _translation8.default;
	      break;
	    case locale.indexOf('it') > -1:
	      translations = _translation10.default;
	      break;
	    case locale.indexOf('pt') > -1:
	      translations = _translation12.default;
	      break;
	    case locale.indexOf('zh') > -1:
	      translations = _translation14.default;
	      break;
	    default:
	      translations = _translation2.default;
	  }
	  return (0, _lodash.cloneDeep)(translations);
	};
	
	exports.default = {
	  init: function init(locale, translations) {
	    this.translations = Object.assign(parseLocale(locale), translations || {});
	  },
	  translate: function translate(key) {
	    return (0, _lodash.get)(this.translations, key);
	  },
	  t: function t(key, param) {
	    var translated = (0, _lodash.get)(this.translations, key);
	    // TODO: increase number of possible params or migrate to i18next
	    if (translated && translated.indexOf('{0}') >= 0) {
	      translated = translated.replace('{0}', param);
	    }
	    return translated;
	  }
	};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_41__;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "showMore": "Show More", "minutes": "min", "button": "View attendees", "noMeetingEvents": "No hosted meetings were found for the specified period.", "recordingDisclaimer": "Recording consumption limits may be added at a future date.", "play": "View recording", "viewTranscript": "View recording & transcript", "processing": "Processing recording...", "shareRecording": "Share recording", "downloadRecording": "Download recording", "deleteRecording": "Delete recording", "diagnostics": "Meeting diagnostics", "copyLinkDlgHeader": "Share Recording", "toggleSharingText": "Sharing", "editTitle": "Edit title", "confirmCopyLink": "Copy", "yes": "Yes", "ok": "Ok", "cancel": "Cancel", "deleteRecordings": { "confirmDialog": { "head": "Delete Recording", "body": "Are you sure you want to permanently delete the recording {0}?" }, "errorDialog": { "head": "Unable to delete recording", "body": "We could not delete your recording at this time. Please try again." } }, "copyRecordingLink": { "confirmMessage": "Your recording link has been copied to the clipboard. You can share your recording by sending this link.", "errorDialog": { "head": "Unable to copy recording link", "body": "We could not copy the recording link at this time. Please try again." } }, "playerControls": { "volume": "Volume", "rewind": "Rewind", "replay": "Replay", "related": "Discover", "prev": "Previous", "playlist": "Playlist", "player": "Video Player", "playbackRates": "Playback rates", "playback": "Start playback", "play": "Play", "pause": "Pause", "nextUpClose": "Next Up Close", "nextUp": "Next Up", "next": "Next", "more": "More", "liveBroadcast": "Live broadcast", "hd": "Quality", "fullscreen": "Fullscreen", "close": "Close", "cc": "Closed captions", "cast": "Chromecast", "buffer": "Loading", "audioTracks": "Audio tracks", "airplay": "Airplay" } };

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "showMore": "Mehr anzeigen", "minutes": "Min.", "button": "Teilnehmer anzeigen", "noMeetingEvents": "Im angegebenen Zeitraum wurden keine Meetings durchgeführt.", "recordingDisclaimer": "Nutzungslimits für die Aufzeichnung werden möglicherweise zu einem späteren Zeitpunkt hinzugefügt.", "play": "Aufzeichnung ansehen", "viewTranscript": "Aufzeichnung und Transkription ansehen", "processing": "Aufzeichnung wird verarbeitet...", "shareRecording": "Aufzeichnung freigeben", "downloadRecording": "Aufzeichnung herunterladen", "deleteRecording": "Aufzeichnung löschen", "diagnostics": "Meeting-Diagnose", "copyLinkDlgHeader": "Aufzeichnung freigeben", "editTitle": "Titel bearbeiten", "confirmCopyLink": "Kopieren", "yes": "Ja", "ok": "OK", "cancel": "Abbrechen", "deleteRecordings": { "confirmDialog": { "head": "Löschen der Aufzeichnung", "body": "Möchten Sie die Aufzeichnung {0} wirklich endgültig löschen?" }, "errorDialog": { "head": "Aufzeichnung kann nicht gelöscht werden", "body": "Die Aufzeichnung konnte zu diesem Zeitpunkt nicht gelöscht werden. Versuchen Sie es noch einmal." } }, "copyRecordingLink": { "confirmMessage": "Ihr Aufzeichnungslink wurde in die Zwischenablage kopiert. Sie können Ihre Aufzeichnung freigeben, indem Sie diesen Link senden.", "errorDialog": { "head": "Aufzeichnungslink kann nicht kopiert werden", "body": "Der Aufzeichnungslink konnte zu diesem Zeitpunkt nicht kopiert werden. Versuchen Sie es noch einmal." } }, "playerControls": { "volume": "Lautstärke", "rewind": "Rücklauf", "replay": "Wiederholen", "related": "Ermitteln", "prev": "Zurück", "playlist": "Wiedergabeliste", "player": "Video Player", "playbackRates": "Playback rates", "playback": "Wiedergabe starten", "play": "Wiedergeben", "pause": "Pausieren", "nextUpClose": "Next Up Close", "nextUp": "Next Up", "next": "Weiter", "more": "Mehr", "liveBroadcast": "Live-Übertragung", "hd": "Qualität", "fullscreen": "Vollbild", "close": "Schließen", "cc": "Untertitel", "cast": "Chromecast", "buffer": "Wird geladen", "audioTracks": "Audiotitel", "airplay": "Airplay" } };

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "showMore": "Mostrar más", "minutes": "min", "button": "Ver asistentes", "noMeetingEvents": "No se ha encontrado ninguna reunión que se organizara en el período especificado.", "recordingDisclaimer": "En el futuro puede que se añadan límites a la reproducción de grabaciones.", "play": "Ver grabación", "viewTranscript": "Ver grabación y transcripción", "processing": "Procesando grabación...", "shareRecording": "Compartir grabación", "downloadRecording": "Descargar grabación", "deleteRecording": "Eliminar grabación", "diagnostics": "Diagnóstico de la reunión", "copyLinkDlgHeader": "Compartir grabación", "editTitle": "Editar título", "confirmCopyLink": "Copiar", "yes": "Sí", "ok": "Aceptar", "cancel": "Cancelar", "deleteRecordings": { "confirmDialog": { "head": "Eliminar grabación", "body": "¿Seguro que quiere eliminar de forma permanente la grabación «{0}»?" }, "errorDialog": { "head": "No se puede eliminar la grabación", "body": "En estos momentos no hemos podido eliminar la grabación. Vuelva a intentarlo." } }, "copyRecordingLink": { "confirmMessage": "Se ha copiado el enlace de la grabación al Portapapeles. Envíe el enlace a quien quiera para compartir la grabación.", "errorDialog": { "head": "No se puede copiar el enlace de la grabación", "body": "No hemos podido copiar el enlace de la grabación. Vuelva a intentarlo." } }, "playerControls": { "volume": "Volumen", "rewind": "Rebobinar", "replay": "Repetir", "related": "Descubrir", "prev": "Anterior", "playlist": "Lista de reproducción", "player": "Reproductor de vídeo", "playbackRates": "Playback rates", "playback": "Iniciar reproducción", "play": "Reproducir", "pause": "Pausar", "nextUpClose": "Next Up Close", "nextUp": "Next Up", "next": "Siguiente", "more": "Más", "liveBroadcast": "Transmisión en directo", "hd": "Calidad", "fullscreen": "Pantalla completa", "close": "Cerrar", "cc": "Subtítulos", "cast": "Chromecast", "buffer": "Cargando", "audioTracks": "Pistas de audio", "airplay": "Airplay" } };

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "showMore": "En afficher davantage", "minutes": "min", "button": "Afficher les participants", "noMeetingEvents": "Aucune réunion ne s’est tenue durant cette période.", "recordingDisclaimer": "Des limites d'utilisation de l'enregistrement peuvent être ajoutées à une date ultérieure.", "play": "Visionner l’enregistrement", "viewTranscript": "Visionner l'enregistrement et la transcription", "processing": "Traitement de l'enregistrement...", "shareRecording": "Partager enregistrement", "downloadRecording": "Télécharger enregistrement", "deleteRecording": "Supprimer enregistrement", "diagnostics": "Diagnostics réunion", "copyLinkDlgHeader": "Partager l'enregistrement", "editTitle": "Modifier le titre", "confirmCopyLink": "Copier", "yes": "Oui", "ok": "OK", "cancel": "Annuler", "deleteRecordings": { "confirmDialog": { "head": "Supprimer l'enregistrement", "body": "Supprimer définitivement l’enregistrement {0} ?" }, "errorDialog": { "head": "Impossible de supprimer l'enregistrement", "body": "Impossible de supprimer votre enregistrement pour le moment. Veuillez réessayer." } }, "copyRecordingLink": { "confirmMessage": "Le lien de votre enregistrement a été copié dans le presse-papiers. Vous pouvez partager votre enregistrement en envoyant ce lien.", "errorDialog": { "head": "Impossible de copier le lien de l’enregistrement", "body": "Impossible de copier le lien de l'enregistrement pour le moment. Veuillez réessayer." } }, "playerControls": { "volume": "Volume", "rewind": "Revenir en arrière", "replay": "Relecture", "related": "Découvrir", "prev": "Précédent", "playlist": "Playlist", "player": "Lecteur vidéo", "playbackRates": "Playback rates", "playback": "Commencer la lecture", "play": "Lire", "pause": "Mettre en pause", "nextUpClose": "Next Up Close", "nextUp": "Next Up", "next": "Suivant", "more": "Suite", "liveBroadcast": "Diffusion en direct", "hd": "Qualité", "fullscreen": "Plein écran", "close": "Fermer", "cc": "Sous-titres", "cast": "Chromecast", "buffer": "Chargement", "audioTracks": "Pistes audio", "airplay": "Airplay" } };

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "showMore": "Mostra dettagli", "minutes": "min", "button": "Visualizza partecipanti", "noMeetingEvents": "Nessuna riunione organizzata per il periodo specificato.", "recordingDisclaimer": "In un secondo momento è possibile aggiungere limiti di consumo della registrazione.", "play": "Visualizza registrazione", "viewTranscript": "Visualizza registrazione e trascrizione", "processing": "Elaborazione registrazione...", "shareRecording": "Condividi registrazione", "downloadRecording": "Scarica registrazione", "deleteRecording": "Elimina registrazione", "diagnostics": "Diagnostica della riunione", "copyLinkDlgHeader": "Condividi registrazione", "editTitle": "Modifica titolo", "confirmCopyLink": "Copia", "yes": "Sì", "ok": "OK", "cancel": "Annulla", "deleteRecordings": { "confirmDialog": { "head": "Elimina registrazione", "body": "Eliminare definitivamente la registrazione {0}?" }, "errorDialog": { "head": "Impossibile eliminare la registrazione", "body": "Impossibile eliminare momentaneamente la registrazione. Riprova." } }, "copyRecordingLink": { "confirmMessage": "Il collegamento di registrazione è stato copiato negli Appunti. Puoi condividere la registrazione inviando questo collegamento.", "errorDialog": { "head": "Impossibile copiare il collegamento di registrazione", "body": "Impossibile copiare momentaneamente il collegamento di registrazione. Riprova." } }, "playerControls": { "volume": "Volume", "rewind": "Riavvolgi", "replay": "Riproduci di nuovo", "related": "Scopri", "prev": "Precedente", "playlist": "Elenco di riproduzione", "player": "Lettore video", "playbackRates": "Playback rates", "playback": "Avvia riproduzione", "play": "Riproduci", "pause": "Sospendi", "nextUpClose": "Next Up Close", "nextUp": "Next Up", "next": "Successivo", "more": "Altro", "liveBroadcast": "Trasmissione in diretta", "hd": "Qualità", "fullscreen": "Schermo intero", "close": "Chiudi", "cc": "Sottotitoli codificati", "cast": "Chromecast", "buffer": "Caricamento", "audioTracks": "Tracce audio", "airplay": "Airplay" } };

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "showMore": "Mostrar mais", "minutes": "min", "button": "Exibir participantes", "noMeetingEvents": "Nenhuma reunião hospedada foi encontrada para o período especificado.", "recordingDisclaimer": "Os limites de consumo de gravação podem ser adicionados em uma data futura.", "play": "Exibir gravação", "viewTranscript": "Exibir gravação e transcrição", "processing": "Processando gravação...", "shareRecording": "Compartilhar gravação", "downloadRecording": "Baixar gravação", "deleteRecording": "Excluir gravação", "diagnostics": "Diagnósticos de reunião", "copyLinkDlgHeader": "Compartilhar gravação", "toggleSharingText": "Compartilhamento", "editTitle": "Editar título", "confirmCopyLink": "Copiar", "yes": "Sim", "ok": "Ok", "cancel": "Cancelar", "deleteRecordings": { "confirmDialog": { "head": "Excluir gravação", "body": "Tem certeza de que deseja excluir permanentemente a gravação {0}?" }, "errorDialog": { "head": "Não é possível excluir a gravação", "body": "Não foi possível excluir sua gravação no momento. Tente novamente." } }, "copyRecordingLink": { "confirmMessage": "Seu link de gravação tem sido copiado para a área de transferência. Você pode compartilhar sua gravação enviando esse link.", "errorDialog": { "head": "Não é possível copiar o link da gravação", "body": "Não foi possível excluir o link de gravação no momento. Tente novamente." } }, "playerControls": { "volume": "Volume", "rewind": "Retroceder", "replay": "Repetir", "related": "Discover", "prev": "Anterior", "playlist": "Lista de reprodução", "player": "Player de vídeo", "playbackRates": "Taxas de reprodução", "playback": "Iniciar reprodução", "play": "Reproduzir", "pause": "Pausar", "nextUpClose": "Next Up Close", "nextUp": "Next Up", "next": "Avançar", "more": "Mais", "liveBroadcast": "Transmissão ao vivo", "hd": "Qualidade", "fullscreen": "Tela inteira", "close": "Fechar", "cc": "Legendas", "cast": "Chromecast", "buffer": "Carregando", "audioTracks": "Faixas de áudio", "airplay": "Airplay" } };

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "showMore": "显示更多", "minutes": "分钟", "button": "查看与会者", "noMeetingEvents": "未找到在指定时间段内召开的会议。", "recordingDisclaimer": "可能会在将来添加录制使用限制。", "play": "查看录制件", "viewTranscript": "查看录制件和脚本", "processing": "正在处理录制文件...", "shareRecording": "共享录制件", "downloadRecording": "下载录制件", "deleteRecording": "删除录制件", "diagnostics": "会议诊断", "copyLinkDlgHeader": "共享录制件", "editTitle": "编辑标题", "confirmCopyLink": "复制", "yes": "是", "ok": "确定", "cancel": "取消", "deleteRecordings": { "confirmDialog": { "head": "删除录制件", "body": "确定要永久删除录制件 {0} 吗?" }, "errorDialog": { "head": "无法删除录制件", "body": "我们当前无法删除您的录制件。请重试。" } }, "copyRecordingLink": { "confirmMessage": "您的录制链接已复制到剪贴板。您可以通过发送此链接来共享您的录制。", "errorDialog": { "head": "无法复制录制链接", "body": "我们目前无法复制录制链接。请重试。" } }, "playerControls": { "volume": "音量", "rewind": "倒带", "replay": "重播", "related": "发现", "prev": "上一个", "playlist": "播放列表", "player": "视频播放器", "playbackRates": "Playback rates", "playback": "开始回放", "play": "播放", "pause": "暂停", "nextUpClose": "Next Up Close", "nextUp": "Next Up", "next": "下一个", "more": "更多", "liveBroadcast": "现场直播", "hd": "质量", "fullscreen": "全屏", "close": "关闭", "cc": "关闭字幕", "cast": "Chromecast", "buffer": "正在加载...", "audioTracks": "音轨", "airplay": "Airplay" } };

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(50);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateTime = function (_React$Component) {
	  _inherits(DateTime, _React$Component);
	
	  function DateTime() {
	    _classCallCheck(this, DateTime);
	
	    return _possibleConstructorReturn(this, (DateTime.__proto__ || Object.getPrototypeOf(DateTime)).apply(this, arguments));
	  }
	
	  _createClass(DateTime, [{
	    key: 'render',
	    value: function render() {
	      var meetingTime = void 0;
	
	      if (this.props.is24Hours) {
	        var meetingStartTime24 = (0, _moment2.default)(this.props.meetingStartTime + ' ' + this.props.meetingStartPeriod, 'hh:mm a').format('HH:mm');
	        meetingTime = _react2.default.createElement(
	          'span',
	          null,
	          meetingStartTime24
	        );
	      } else {
	        meetingTime = _react2.default.createElement(
	          'span',
	          null,
	          this.props.meetingStartTime + ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'timeformat-wrapper' },
	            this.props.meetingStartPeriod
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-2 meeting-time ' + this.props.className },
	        _react2.default.createElement(
	          'div',
	          { className: 'date-wrapper' },
	          this.props.meetingDate
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'time-wrapper' },
	          meetingTime
	        )
	      );
	    }
	  }]);
	
	  return DateTime;
	}(_react2.default.Component);
	
	exports.default = DateTime;
	
	
	DateTime.propTypes = {
	  is24Hours: _propTypes2.default.bool,
	  meetingStartTime: _propTypes2.default.string.isRequired,
	  meetingStartPeriod: _propTypes2.default.string.isRequired,
	  meetingDate: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string
	};
	
	DateTime.defaultProps = {
	  is24Hours: false
	};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_50__;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(50);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _internationalization = __webpack_require__(40);
	
	var _internationalization2 = _interopRequireDefault(_internationalization);
	
	__webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  meetingEndTime: _propTypes2.default.string.isRequired,
	  meetingId: _propTypes2.default.string,
	  meetingStartTime: _propTypes2.default.string.isRequired,
	  sessionId: _propTypes2.default.string,
	  subject: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string
	};
	
	var MeetingInfo = function MeetingInfo(_ref) {
	  var meetingId = _ref.meetingId,
	      sessionId = _ref.sessionId,
	      subject = _ref.subject,
	      meetingStartTime = _ref.meetingStartTime,
	      meetingEndTime = _ref.meetingEndTime,
	      className = _ref.className;
	
	  var duration = (0, _moment2.default)(meetingEndTime).diff(meetingStartTime, 'minutes');
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'meeting-subject past',
	        'data-meeting-id': meetingId,
	        'data-session-id': sessionId
	      },
	      subject
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'meeting-difference' },
	      _react2.default.createElement(
	        'span',
	        null,
	        duration
	      ),
	      ' ',
	      _internationalization2.default.translate('minutes')
	    )
	  );
	};
	
	exports.default = MeetingInfo;
	
	MeetingInfo.propTypes = propTypes;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _internationalization = __webpack_require__(40);
	
	var _internationalization2 = _interopRequireDefault(_internationalization);
	
	__webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Attendees = function (_React$Component) {
	  _inherits(Attendees, _React$Component);
	
	  function Attendees() {
	    _classCallCheck(this, Attendees);
	
	    return _possibleConstructorReturn(this, (Attendees.__proto__ || Object.getPrototypeOf(Attendees)).apply(this, arguments));
	  }
	
	  _createClass(Attendees, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'meeting-options' },
	          _react2.default.createElement(
	            'span',
	            { className: 'sessions' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-link', onClick: function onClick() {
	                  return _this2.props.viewAttendees(_this2.props.meetingData);
	                } },
	              _internationalization2.default.translate('button'),
	              ' ',
	              '(',
	              this.props.attendeesCount,
	              ')'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Attendees;
	}(_react2.default.Component);
	
	exports.default = Attendees;
	
	
	Attendees.propTypes = {
	  meetingData: _propTypes2.default.object.isRequired,
	  attendeesCount: _propTypes2.default.number.isRequired,
	  viewAttendees: _propTypes2.default.func
	};
	
	Attendees.defaultProps = {
	  viewAttendees: function viewAttendees() {}
	};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (attendees) {
	  return attendees.reduce(function (acc, curr) {
	    var currentName = curr.name.toLowerCase();
	    return acc.includes(currentName) ? acc : acc.concat(curr.name.toLowerCase());
	  }, []).length;
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _internationalization = __webpack_require__(40);
	
	var _internationalization2 = _interopRequireDefault(_internationalization);
	
	__webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShowMore = function (_React$Component) {
	  _inherits(ShowMore, _React$Component);
	
	  function ShowMore() {
	    _classCallCheck(this, ShowMore);
	
	    return _possibleConstructorReturn(this, (ShowMore.__proto__ || Object.getPrototypeOf(ShowMore)).apply(this, arguments));
	  }
	
	  _createClass(ShowMore, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-4 col-sm-offset-2 show-more-meetings' },
	        _react2.default.createElement(
	          'span',
	          { className: 'hover-like-link' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-link', onClick: this.props.showMore },
	            _internationalization2.default.translate('showMore')
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShowMore;
	}(_react2.default.Component);
	
	exports.default = ShowMore;
	
	
	ShowMore.propTypes = {
	  showMore: _propTypes2.default.func
	};
	
	ShowMore.defaultProps = {
	  showMore: function showMore() {}
	};

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(64);
	
	var _internationalization = __webpack_require__(40);
	
	var _internationalization2 = _interopRequireDefault(_internationalization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecordingDisclaimer = function (_Component) {
	  _inherits(RecordingDisclaimer, _Component);
	
	  function RecordingDisclaimer(props) {
	    _classCallCheck(this, RecordingDisclaimer);
	
	    return _possibleConstructorReturn(this, (RecordingDisclaimer.__proto__ || Object.getPrototypeOf(RecordingDisclaimer)).call(this, props));
	  }
	
	  _createClass(RecordingDisclaimer, [{
	    key: 'render',
	    value: function render() {
	      var recordingDisclaimer = null;
	      if (!this.props.hidden) {
	        recordingDisclaimer = _react2.default.createElement(
	          'div',
	          { className: 'recording-disclaimer-container' },
	          _react2.default.createElement('i', { className: 'togo-icon togo-icon-info togo-icon-lg' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'recording-disclaimer' },
	            _internationalization2.default.translate('recordingDisclaimer')
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6' },
	        recordingDisclaimer
	      );
	    }
	  }]);
	
	  return RecordingDisclaimer;
	}(_react.Component);
	
	exports.default = RecordingDisclaimer;
	
	
	RecordingDisclaimer.propTypes = {
	  hidden: _propTypes2.default.bool
	};
	
	RecordingDisclaimer.defaultProps = {
	  hidden: false
	};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _internationalization = __webpack_require__(40);
	
	var _internationalization2 = _interopRequireDefault(_internationalization);
	
	__webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NoMeetings = function (_React$Component) {
	  _inherits(NoMeetings, _React$Component);
	
	  function NoMeetings() {
	    _classCallCheck(this, NoMeetings);
	
	    return _possibleConstructorReturn(this, (NoMeetings.__proto__ || Object.getPrototypeOf(NoMeetings)).apply(this, arguments));
	  }
	
	  _createClass(NoMeetings, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'row no-meetings' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-9 col-sm-offset-2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _internationalization2.default.translate('noMeetingEvents')
	          )
	        )
	      );
	    }
	  }]);
	
	  return NoMeetings;
	}(_react2.default.Component);
	
	exports.default = NoMeetings;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */,
/* 69 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ])
});
;
//# sourceMappingURL=MeetingHistory.js.map;
